/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './dealCard.module.scss';
import { formatValue } from './utils';

const DealCard = ({ data, alignment }) => {
  const { title, value, gradient, icon } = data;
  return (
    <div className={styles['deal-card']}>
      <div className={styles['deal-card-title']}>{title}</div>
      <div className={styles['deal-card-value-box']}>
        <div className={styles['deal-card-icon']} style={{ background: gradient }}>
          <img src={icon} alt="icon" />
        </div>
        <div className={styles['deal-card-value']}>
          {alignment === 'Value' ? '$' : ''}
          {formatValue(value, alignment)}
        </div>
      </div>
    </div>
  );
};

// Prop validation using PropTypes
DealCard.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    gradient: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
  }).isRequired,
  alignment: PropTypes.oneOf(['Value', 'Other']).isRequired, 
};

export default DealCard;

DealCard.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,    
    value: PropTypes.any,   
    gradient: PropTypes.any, 
    icon: PropTypes.any,     
  }).isRequired,
  alignment: PropTypes.any, 
};

